import styled from "styled-components";

import { FaFacebookSquare, FaTiktok } from 'react-icons/fa'

import { BsInstagram } from 'react-icons/bs'

export const ColorMain = '#F4D394';

export const ColorSec = '#62543B';

export const ColorWhite = '#E4E6EB';

export const ColorFooter = '#312a1E'

export const ColorRed = '#C94527';

export const FontSigmar = `'Sigmar One', cursive`;

export const SocialMedia = styled.div`
  display: flex;
  gap: 30px;
`
export const Facebook = styled(FaFacebookSquare)`
  color: #62543B;
  font-size: 42px;
`
export const Instagram = styled(BsInstagram)`
  color: #62543B;
  font-size: 42px;
`
export const Tiktok = styled(FaTiktok)`
  color: #62543B;
  font-size: 42px;
`
export const Title = styled.h2`
  color: #E4E6EB;
  font-size: 30px;
  line-height: 30px;
  text-align: center;
  @media (min-width: 992px) {
    font-size: 36px;
    line-height: 36px;
  }
`